import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { CountryDecoder } from './CountryDecoder.js';
import { Province } from './Province.js';
export class City extends AutoEncoder {
    id;
    name;
    province;
    parentCityId = null;
    country;
}
__decorate([
    field({ decoder: StringDecoder })
], City.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], City.prototype, "name", void 0);
__decorate([
    field({ decoder: Province })
], City.prototype, "province", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], City.prototype, "parentCityId", void 0);
__decorate([
    field({ decoder: CountryDecoder })
], City.prototype, "country", void 0);
//# sourceMappingURL=City.js.map